import * as THREE from "three";

const STOPS: readonly [number, THREE.Color][] = [
  [0, new THREE.Color("#16c9f4")],
  [0.35, new THREE.Color("#1688ff")],
  [0.7, new THREE.Color("#7457ff")],
  [1, new THREE.Color("#d51ee8")],
];

/** Mirrors the `--accent-gradient` CSS token so three.js scenes can sample the same ramp. */
export function sampleAccentGradient(t: number): THREE.Color {
  const clamped = Math.min(1, Math.max(0, t));
  for (let i = 0; i < STOPS.length - 1; i++) {
    const [stopA, colorA] = STOPS[i] as [number, THREE.Color];
    const [stopB, colorB] = STOPS[i + 1] as [number, THREE.Color];
    if (clamped >= stopA && clamped <= stopB) {
      const localT = (clamped - stopA) / (stopB - stopA);
      return colorA.clone().lerp(colorB, localT);
    }
  }
  return (STOPS[STOPS.length - 1] as [number, THREE.Color])[1].clone();
}
